var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/games/gamesSwitcher.jade
 ** module id = 830
 ** module chunks = 0
 **/